import { UnleashClient } from 'unleash-proxy-client';

export default new UnleashClient({
    url: 'https://unleash.lunchpad.ru/proxy',
    clientKey: 'lunchpad-secret',
    appName: 'production',
});